import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaCheck } from 'react-icons/fa';



const Plan = ({ plan }) => {

  const { title, content, price, unit, features } = plan; // Extracting data from plan

  return (
    <div className="price-item">

      <div className='intro'>
        <h3>{title}</h3> {/* Plan Title */}
        <p>{content}</p> {/* Plan Description */}
        <div className="price">${price}<span>/{unit}</span></div> {/* Plan Price */}
      </div>

      <Button link={"Get-Quote"} title={"Get Quote"} />

      {/* List of Features */}
      <ul>
        {features.map((feature, index) => (
          <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
        ))}
      </ul>

    </div>
  );
};

export default Plan;